<div class="integration-spinner">
  <span class="spinner-text" translate>PROCESSING_INTEGRATION</span>
  <div class="loading">
    <div class="spin-circle"></div>
  </div>
</div>
